
















































import { Component, Vue } from "vue-property-decorator";

@Component
export default class ProductsMarkets extends Vue {
  loading = false;

  menu = [
    {
      title: "Prodotti",
      subtitle: "Aggiungi nuovi prodotti turistici e modifica i prodotti esistenti",
      to: "/product",
    },
    {
      title: "Attrattori",
      subtitle: "Aggiorna la mappa degli attrattori collegati alla tua offerta turistica",
      to: "/attractors",
    },
    {
      title: "Mercati",
      subtitle: "Definisci la domanda attuale o potenziale per la tua destinazione",
      to: "/markets",
    },
    {
      title: "Tabella Prodotti/Mercati",
      subtitle: "Rivedi e controlla le scelte di strategia di prodotto-mercato",
      to: "/products-markets-matrix",
    },
  ];

  onSurveyTypeClick(to: string) {
    this.$router.push(to).catch(error => console.log(error));
  }
}
